import { addToListLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsAddToListLink";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import PlusCircle from "@insite/mobius/Icons/PlusCircle";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { COLORS } from "@store/theme/design";
import merge from "lodash/merge";
import { css } from "styled-components";

// TODO: ISA REFACTOR
merge(addToListLinkStyles, {
    wrapper: {
        css: css`
            margin-top: 15px;
            padding-top: 15px;
            text-align: left;
            border-top: 1px solid ${COLORS.border.base};
        `,
    },
    link: {
        link: {
            icon: {
                iconProps: {
                    src: PlusCircle,
                    css: css`
                        svg {
                            fill: #000;
                            stroke: white;
                        }
                    `,
                },
                position: "left",
            },
            typographyProps: {
                css: css`
                    text-align: left;
                    color: #000;
                    font-weight: bold;
                    margin-left: 3px;
                `,
            },
            hoverMode: "lighten",
        },
    },
});
